import { Component, Input, OnInit } from '@angular/core';
/*
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireObject, AngularFireDatabase } from 'angularfire2/database';
*/
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RightinfoService } from '../../service/rightinfo.service';
import { TripList } from '../../models/TripList';
// import { Query } from '@firebase/database';
import { AwsService } from '../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-adminmap',
  templateUrl: './adminmap.component.html',
  styleUrls: ['./adminmap.component.css']
})
export class AdminmapComponent implements OnInit {

  markers = [];
  centerPosition = {"lat" : 12.73377, "lng" : 80.011268}
  users: Observable<any>;
  totaltrips: Observable<any[]>;
  userList: any;
  // ref: Query;
  runningTrips:any;
  alerts: Observable<any>;
  alertJson :any;
  alertList :Observable<any>;
  triplist:TripList[];

  databaseRef: Observable<any>;
  completeddata : number = 0;
  compdrivercount = new Set();
  completedList: any;
  totalTripCount=0;
  driverlivecount =0;
  getType: any

  // zoom: number = 12;
  // initial center position for the map
  // lat : number= 12.73377 ;
  // lng : number= 80.011268 ;

  constructor(public awserviceProvider: AwsService, private router: Router, private route: ActivatedRoute, private rightinfoService: RightinfoService) {

    this.markersAgm();
  }

  ngOnInit() {
  this.runningTrips=[];
  }

  markersAgm() {

    let dateFormat = require('dateformat');
    let now = new Date();
   // now.setDate(now.getDate() + 1);
    let today = dateFormat(now, "yyyy-mm-dd");
    let tomo = new Date();
     tomo.setDate(tomo.getDate() + 1);
     let tomorrow = dateFormat(tomo, "yyyy-mm-dd");

    var that = this
    this.awserviceProvider.getTripsByStatus(1,today,tomorrow).then(running => {
      let runningList: any = running;
      console.log("running",running)
      runningList.forEach(trip => {
        this.awserviceProvider.getUserTripByDriverId(trip.id, trip.driver_id).then(usertrip => {
          trip.loc = usertrip[0];
          console.log("usertrip[0]",usertrip[0])
        })
           // alert(trip.cab_id)
           this.awserviceProvider.getScCabMasterById(trip.cab_id).then(cab => {
            trip.cab = {};
            trip.cab = cab;
            console.log("222222", trip.cab)
          })
        this.awserviceProvider.getRncUsers(trip.driver_id).then(driver => {
          trip.driver = driver;
          this.runningTrips.push(trip);
          console.log("driver",driver)
        })
            //trip position_values
            this.awserviceProvider.getScTripPosition(trip.id).then(positiondata =>{
              console.log("positiondata",positiondata)
              if(positiondata!=null){
              var positions = positiondata.position;
              var last_element = positions[positions.length - 1];
              var lati = last_element.lat;
              var longi = last_element.long;
              let markertip=trip.cab.vehicle_no+"-"+(trip.trip_type==0?'Pick-up':'Drop')
             // let markertip=trip.trip_type==0?'Pick-up':'Drop'+"-"+dateFormat(trip.scheduled_date, "yyyy-mm-dd HH:MM:ss"); 
              this.addMarkerUserTrip(markertip, lati, longi)
              this.centerPosition = this.calculateAverageGeolocation(this.markers)
            }
            }).catch(error => {
              console.log(error)
            })


      })
    });


    // this.awserviceProvider.getListUserTrips().then(fulldata =>{
    //   console.log("fulldata", fulldata)
    //   this.userList = fulldata
    //   this.userList.forEach(element => {
    //       this.awserviceProvider.getUser(element.user_id).then( singleuser =>{
    //           this.getType = singleuser.user_type
    //       if (element.trip_status == 1 && this.getType == 2){
    //     var positionId = element.user_id + "_" + element.trip_id
    //     console.log("positionId", positionId)

    //     //trip position_values
    //     this.awserviceProvider.getTripPositionDetail(positionId).then(positiondata =>{
    //       var test = positiondata.position;
    //       var last_element = test[test.length - 1];
    //       var lati = last_element.lat;
    //       var longi = last_element.long;

    //       this.addMarkerUserTrip(positionId, lati, longi)
    //       this.centerPosition = this.calculateAverageGeolocation(this.markers)
    //     }).catch(error => {
    //       console.log(error)
    //     })
    //   }
    // })
    //   });
    // }).catch(error => {
    //   console.log(error)
    // })


    // this.awserviceProvider.getTripPositionAllDetails().then(data =>{

    //   console.log("getTripPositionAllDetails", data)

    //   this.userList = data

    //   for (var i = 0; i < this.userList.length; i++) {
    //         var usertrip = this.userList[i];
    //         var test = this.userList[i].positions;
    //         var last_element = test[test.length - 1];
    //         var lati = last_element.lat;
    //         var longi = last_element.long;
    //         var tripId = usertrip.id;

    //         this.addMarkerUserTrip(tripId, lati, longi)
  
    //       }
    // })
    // .catch(error => {
    //   console.log(error)
    // })

    //this.users = this.db.collection('UserTrips', ref => ref.orderBy('trip_id')).valueChanges()

    // this.users.subscribe(data => {
    //   this.userList = data

    //   for (var i = 0; i < this.userList.length; i++) {
    //     var usertrip = this.userList[i];
    //     var test = this.userList[i].positions;
    //     var last_element = test[test.length - 1];
    //     var lati = last_element.lat;
    //     var longi = last_element.long;
    //     var tripId = usertrip.user_id + "_" + usertrip.trip_id;

    //     var start = usertrip.startAddress;
    //     var end = usertrip.endAddress;

    //     if (usertrip.is_completed == 1 && tripId.includes('Driver')) {
    //       this.addMarkerUserTrip(tripId, lati, longi)
    //     }

    //   }
    // })
  }

  addMarkerUserTrip(userTripId, lati, longi) {
    console.log("userTripId", userTripId)
    // this.markers = this.markers.filter((element) => {
    //   if (element.tripName == userTripId) {
    //     return false
    //   } else {
    //     return true
    //   }
    // })

    var marker = {
      lat: lati,
      lng: longi,
      iconUrl: "assets/images/cab.png",
      tripName: userTripId
    }
    this.markers.push(marker);
  }

  calculateAverageGeolocation(coords) {
    if (coords.length === 1) {
      return coords[0]
    }
    let x = 0.0
    let y = 0.0
    let z = 0.0
    for (let coord of coords) {
      let latitude = coord.lat * Math.PI / 180
      let longitude = coord.lng * Math.PI / 180
      x += Math.cos(latitude) * Math.cos(longitude)
      y += Math.cos(latitude) * Math.sin(longitude)
      z += Math.sin(latitude)
    }
    let total = coords.length
    x = x / total
    y = y / total
    z = z / total
    let centralLongitude = Math.atan2(y, x)
    let centralSquareRoot = Math.sqrt(x * x + y * y)
    let centralLatitude = Math.atan2(z, centralSquareRoot)
    return {
      lat: centralLatitude * 180 / Math.PI,
      lng: centralLongitude * 180 / Math.PI
    }
  }
}
